import movLogo from 'url:../img/mov.png';
import occoApi from './occoAPI.js';
import { LANG } from '../lang/prop_en.js';
import { MEDIA_TYPE_IMAGE, MEDIA_TYPE_VIDEO } from './constants.js';
import { SETTINGS_PARAMS } from './settingsConstants.js';

const ERROR_CODES = {
  ROBOT_NAME_IS_ALREADY_EXIST:
    "{robot_name} can't be created as it already exists in {org_name} Organization. Please choose a different name.",
};
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // Email address

export function getErrorMessage(code) {
  let message = code;
  if (ERROR_CODES[code] !== undefined) {
    message = ERROR_CODES[code];
  }
  return message;
}

export function hashDiff(h1, h2) {
  const d = {};
  for (const k in h2) {
    if (h1[k] !== h2[k]) d[k] = h2[k];
  }
  return d;
}

export function isBlank(str) {
  return str === null || str === undefined || str === '';
}

export function tryJson(str, defaultVal) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return defaultVal;
  }
}

export function convertSerializedArrayToHash(a) {
  const r = {};
  for (let i = 0; i < a.length; i++) {
    r[a[i].name] = $.trim(a[i].value);
  }
  return r;
}

export function getRoleNameById(id) {
  let name = '';
  switch (id) {
    case 1:
      name = 'Super Admin';
      break;
    case 2:
      name = 'Admin';
      break;
    case 3:
      name = 'Viewer';
      break;
  }
  return name;
}

export function populate(frm, data) {
  $.each(data, (key, value) => {
    // Skip empty or invalid keys that would cause jQuery selector errors
    if (!key || typeof key !== 'string' || key.trim() === '') {
      return; // Continue to next iteration
    }

    try {
      // Use quotes around attribute value for proper jQuery selector syntax
      const $obj = $(`[name="${key}"]`, frm);
      if ($obj.length > 0) {
        if ($obj.attr('type') === 'checkbox') {
          $obj.prop('checked', value != 0);
        }
        $obj.val(value);
      }
    } catch (e) {
      console.error('Error populating field:', key, e);
    }
  });
}

export function seperateOtherParamsArray(data) {
  const arr = [];
  $.each(data, (key, value) => {
    if (
      key !== 'robot' &&
      key !== 'IS_LOCAL_CONFIG_UPDATED' &&
      SETTINGS_PARAMS.END_USER.indexOf(key) === -1 &&
      SETTINGS_PARAMS.PHOTO_DIST.indexOf(key) === -1 &&
      SETTINGS_PARAMS.CAMERA.indexOf(key) === -1 &&
      SETTINGS_PARAMS.ADMIN.indexOf(key) === -1 &&
      SETTINGS_PARAMS.PERSON_TRACK.indexOf(key) === -1 &&
      SETTINGS_PARAMS.WATERMARK.indexOf(key) === -1
    ) {
      arr.push(key);
    }
  });
  return arr;
}

export function copyToClipboard(text) {
  window.prompt('OCCO Robot ID', text);
}

export function isSuper() {
  const role = Storage.getLocalItem('role');
  if (role === '1') {
    return true;
  }
  return false;
}

export function isAdmin() {
  const role = Storage.getLocalItem('role');
  if (role === '2') {
    return true;
  }
  return false;
}

export function updatePermissions() {
  if (!isSuper()) {
    $('.SUPERUSER').hide();
    if (!isAdmin()) {
      $('.ADMINUSER').hide();
    }
  }
}

export var Storage = {
  setLocalItem(key, value) {
    localStorage.setItem(key, value);
  },

  getLocalItem(key) {
    return localStorage.getItem(key);
  },

  removeLocalItem(key) {
    localStorage.removeItem(key);
  },
};

String.prototype.replaceAll = function (search, replacement) {
  const target = this;
  return target.split(search).join(replacement);
};

export function escStr(str) {
  str = str.replace(/(<([^>]+)>)/gi, '');
  return str;
}

String.prototype.escape = function () {
  const tagsToReplace = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
  };
  return this.replace(/[&<>]/g, (tag) => tagsToReplace[tag] || tag);
};

export function importHtmlFiles(callback) {
  jQuery(document).ready(() => {
    callback();
  });
}
$.fn.serializeObject = function () {
  const o = {};
  const a = this.serializeArray();
  $.each(a, function () {
    if (o[this.name] !== undefined) {
      if (!o[this.name].push) {
        o[this.name] = [o[this.name]];
      }
      o[this.name].push(this.value || '');
    } else {
      o[this.name] = this.value || '';
    }
  });
  const $radio = $('input[type=radio],input[type=checkbox]', this);
  $.each($radio, function () {
    if (!o.hasOwnProperty(this.name)) {
      o[this.name] = this.value ? Number.parseInt(this.value, 10) : '';
    }
  });
  return o;
};

export function fromUrlFilename(url) {
  if (!url) {
    return url;
  }
  return url.split('/').pop();
}

export function normaliseUrl(url) {
  if (!url) {
    return url;
  }
  const fileName = fromUrlFilename(url);
  return url.replace(fileName, '') + encodeURIComponent(fileName);
}

export function generateRandomFileName(originalFileName) {
  let fileType = '';
  if (originalFileName && originalFileName.lastIndexOf('.') != -1) {
    fileType = originalFileName.substr(originalFileName.lastIndexOf('.') + 1);
  }

  const res = `${Math.random().toString(36).substring(7)}.${fileType}`;
  return res;
}

export function generateTid2() {
  return (Date.now() - new Date('2017-01-01').getTime()) * 8192 + Math.floor(Math.random() * 8192);
}

export function uploadAsset(form, { callbackProgress, callbackFail, callbackSuccess }) {
  let contentType = null;
  form.fileupload({
    url: form.attr('action'),
    type: 'POST',
    datatype: 'xml',
    add(event, data) {
      let fileName = data.files[0].name;
      contentType = data.files[0].type;
      fileName = fileName.replaceAll(/\s/g, '');
      const rootPath = 'tmp/';
      const fileRelativePath = `${rootPath + generateTid2()}/${fileName}`;
      occoApi.assetTmpUploadAccessRetrieve(fileRelativePath, (err, result) => {
        if (err) {
          return alert(err.message_key);
        }
        form.attr('action', result.url);
        form.find('input[name=key]').val(fileRelativePath);
        form.find('input[name=Content-Type]').val(data.files[0].type);
        form.find('input[name=X-Amz-Credential]').val(result.fields['X-Amz-Credential']);
        form.find('input[name=X-Amz-Algorithm]').val(result.fields['X-Amz-Algorithm']);
        form.find('input[name=X-Amz-Date]').val(result.fields['X-Amz-Date']);
        form.find('input[name=X-Amz-Security-Token]').val(result.fields['X-Amz-Security-Token']);
        form.find('input[name=Policy]').val(result.fields.Policy);
        form.find('input[name=X-Amz-Signature]').val(result.fields['X-Amz-Signature']);
        // Message on unLoad.
        window.onbeforeunload = function () {
          return LANG.unsaved_message;
        };
        // Submit
        data.submit();
      });
    },
    send(e, data) {
      // onSend
    },
    progress(e, data) {
      callbackProgress(e, data);
    },
    fail(e, data) {
      // Remove 'unsaved changes' message.
      window.onbeforeunload = null;
      callbackFail();
    },
    success(data) {
      // onSuccess
      const filePath = $(data).find('Key')[0].childNodes[0].nodeValue;
      callbackSuccess(filePath, contentType);
    },
    done(event, data) {},
  });
}

export function activateMultiEmail(id) {
  $(`#${id}`).tagsInput({
    width: 'auto',
    pattern: emailRegex,
    defaultText: 'Email', // default: false
    height: 'auto',
  });
}

export function fixPopupOverlays() {
  $(document).on('show.bs.modal', '.modal', function () {
    const zIndex = 1040 + 10 * $('.modal:visible').length;
    $(this).css('z-index', zIndex);
    setTimeout(() => {
      $('.modal-backdrop')
        .not('.modal-stack')
        .css('z-index', zIndex - 1)
        .addClass('modal-stack');
    }, 0);
  });
}
fixPopupOverlays();

export function deleteBg(bg) {
  $(`#${bg}Cont`).empty();
  $(`#hidden${bg}Path`).val('');
  $(`#${bg}Path`).hide('a');
  updateUplProgIndicator($(`#${bg}Progress`));
}

export function getShortListByComma(list) {
  const arrList = list.split(',');
  let shortedList = `<span title='${list}'>`;
  if (arrList.length > 3) {
    for (let i = 0; i < 3; i++) {
      shortedList += `${arrList[i]},`;
    }
    shortedList += '...';
  } else {
    shortedList += list;
  }

  shortedList += '</span>';
  return shortedList;
}

/** @param {string} id */
export function elById(id) {
  return $(`#${id}`);
}

export const isChecked = (selector) => +$(selector).is(':checked');

export function isEmptyList(list) {
  return !Array.isArray(list) || !list.length;
}

export function mediaType(contentType) {
  if (!contentType) return undefined;
  const ct = String(contentType).toLowerCase();
  if (ct.includes('image')) {
    return MEDIA_TYPE_IMAGE;
  }
  if (ct.includes('video')) {
    return MEDIA_TYPE_VIDEO;
  }
  return undefined;
}

export function detectMediaType(src) {
  if (src.match(/\.(jpeg|jpg|gif|png)$/i) != null) {
    return MEDIA_TYPE_IMAGE;
  }
  if (src.match(/\.(mp4|webm|ogg|mov)$/i) != null) {
    return MEDIA_TYPE_VIDEO;
  }
  return undefined;
}

export function hasExtension(ext, path) {
  return path?.toLowerCase().endsWith(ext) || false;
}

export function showElement(selector) {
  $(selector).show();
}

export function hideElement(selector) {
  $(selector).hide();
}

export function buildMediaHtml(type, src) {
  if (type === 'video') {
    return `<video class="mediaCont" src="${src}"></video>`;
  }
  if (type === 'image') {
    return `<img class="mediaCont" src="${src}">`;
  }
  if (type === 'movie') {
    return `<div class="mediaCont"><img class="movIcon" src="${movLogo}"><br><div class="movInfo">MOV file preview is not supported</div></div>`;
  }
}

export function addContentHtml(mediaContent, src, srcType) {
  if (srcType === MEDIA_TYPE_IMAGE) {
    mediaContent.html(buildMediaHtml('image', src));
  } else if (hasExtension('mov', src)) {
    mediaContent.html(buildMediaHtml('movie', null));
  } else {
    mediaContent.html(buildMediaHtml('video', src));
  }
}

export function updateUplProgIndicator(cont, data) {
  let percent = 0;
  if (data) {
    percent = Math.round((data.loaded / data.total) * 100);
  }
  cont.css('width', `${percent}%`);
}
